import React, { Context } from 'react';
import { Socket } from 'socket.io-client';

export const SocketContext: Context<Socket | undefined> = React.createContext<Socket | undefined>(undefined);
